import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { ApiKeyType } from '@root/globalTypes';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';

export const useListApiKeys = (merchantId: string) => {
  const { isLogged } = useCheckUserPermissions();
  const { query } = useApi();
  const { data, isPending } = useQuery<ApiKeyType[], unknown>({
    queryKey: [queryKeys.merchantApiKeys, merchantId],
    queryFn: (): Promise<ApiKeyType[]> =>
      query({
        path: `v1/staff/merchants/${merchantId}/api_keys`,
      }),
    enabled: isLogged,
  });

  return {
    data: data || [],
    isPending,
  };
};
